import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AboutUs from "../About_Us/AboutUs";
import Careers from "../Careers/Careers";
import ContactUs from "../ContactUs/ContactUs";
import HowItWorks from "../Home/HowItWorks";
import LoginIcon from "@mui/icons-material/Login";
import { useDispatch, useSelector } from "react-redux";
import { setActiveSubTab, setTabIndex } from "../../ReduxStore/UserSlice";
import LogoutDialog from "../../components/common/LogoutDialog";
import NextStepCard from "../Home/NextStepCard";
import LoanEligibilityCalculator from "../LoanEligibilityCalculator/LoanEligibilityCalculator";
import LoginScreen from "../login/LoginScreen";
import OTPVerification from "../login/OTPVerification";
import RegisterUser from "../login/RegisterUser";
import WelcomeScreen from "../login/WelcomeScreen";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import GroupIcon from "@mui/icons-material/Group";
import AddIcon from "@mui/icons-material/Add";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { toast } from "react-toastify";

const menuItemStyles = {
  py: 1.8,
  px: 2.5,
  borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
  "&:hover": {
    bgcolor: "rgba(0, 74, 173, 0.04)",
  },
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  transition: "all 0.2s",
};

const iconBoxStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#004AAD",
  fontSize: 20,
  bgcolor: "rgba(0, 74, 173, 0.08)",
  width: 36,
  height: 36,
  borderRadius: "50%",
};

const selectedStyle = {
  pl: 4,
  color: "white",
  backgroundColor: "#1565C0", // softer blue
  borderRadius: "12px",
  boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
  transition: "all 0.3s ease",
  marginY: "6px", // spacing above & below (prevents overlap)
  paddingY: "6px", // inner padding for better height
  "&:hover": {
    backgroundColor: "#0D47A1", // darker blue on hover
    transform: "scale(1.02)",
    boxShadow: "0 5px 12px rgba(0,0,0,0.25)",
  },
};

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showLoginScreen, setShowLoginScreen] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showMobileOTP, setShowMobileOTP] = useState(false);
  const [showOTPVarification, setShowOTPVarification] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [redirectToApplyLoan, setRedirectToApplyLoan] = useState(false);
  const userDetail = useSelector((state) => state.user.user);
  const [requestData, setRequestData] = useState({});
  const activeSubTab = useSelector((state) => state.user.activeSubTab);
  const [openHowItWorks, setOpenHowItWorks] = useState(false);
  const [anchorE2, setAnchorE2] = useState(null);
  const isAuthenticated =
    useSelector((state) => state.user?.user?.jwtToken) ||
    localStorage.getItem("jwtToken");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorApplyEl, setAnchorApplyEl] = useState(null);
  const [applyEntityOpen, setApplyEntityOpen] = useState(false);
  const pathToTabIndex = {
    "/": 1,
    "/how-it-works": 2,
    "/apply-loan": 3,
    "/about-us": 4,
    "/careers": 5,
    "/contact-us": 6,
    "/calculator": 7,
    "/sme-advisory": 8,
  };

  const currentTabIndex = pathToTabIndex[currentPath] || -1;
  const isConsultant = (
    (userDetail?.UserType || userDetail?.userType || "")
      .toString()
      .toLowerCase()
  ) === "consultant";

  useEffect(() => {
    if (pathToTabIndex[currentPath]) {
      dispatch(setTabIndex(pathToTabIndex[currentPath]));
    }
  }, [currentPath, dispatch]);

  useEffect(() => {
    setAnchorEl(null);
    setAnchorE2(null);
  }, [isAuthenticated]);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleTab = (tabValue) => {
    try {
      const paths = {
        1: "/",
        2: "/how-it-works",
        3: "/apply-loan",
        4: "/about-us",
        8: "/sme-advisory",
        5: "/careers",
        6: "/contact-us",
        7: "/calculator",
      };

      if (tabValue === 3) {
        if (isAuthenticated) {
          window.open("/apply-loan", "_blank");
        } else {
          setRedirectToApplyLoan(true);
          setShowLoginScreen(true);
        }
        dispatch(setTabIndex(3));
        return;
      }

      if (paths[tabValue]) {
        const isDashboardContext =
          currentPath.includes("/dashboard") ||
          currentPath === "/profile" ||
          currentPath === "/application-history" ||
          currentPath === "/notification-settings" ||
          currentPath === "/apply-loan" ||
          currentPath === "/resume-application" ||
          currentPath === "/accepted-offers" ||
          currentPath.startsWith("/proposal-details") ||
          currentPath === "/calculators";

        if (isDashboardContext && isAuthenticated) {
          if (tabValue === 2) {
            navigate("/dashboard/how-it-works");
          } else if (tabValue === 6) {
            navigate("/dashboard/contact-us");
          } else {
            navigate(paths[tabValue]);
          }
        } else {
          navigate(paths[tabValue]);
        }
        const numericTabValue = Number(tabValue);
        dispatch(setTabIndex(isNaN(numericTabValue) ? 1 : numericTabValue));
      }
    } catch (error) {
      console.error("Error in handleTab:", error);
      navigate("/");
    }
  };

  const handleLogin = () => {
    setRedirectToApplyLoan(false);
    setTimeout(() => {
      setShowLoginScreen(true);
    }, 100);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(true);
    setAnchorEl(null);
  };

  const handleUserMenuOpen = (event) => {
    setAnchorE2(event?.currentTarget);
  };

  const handleUserMenuDrawerOpen = () => {
    setAnchorE2(true);
  };

  const handleUserMenuClose = () => {
    setAnchorE2(null);
  };

  const handleDashboardClick = () => {
    window.open("/dashboard", "_blank");
    setAnchorE2(null);
  };

  // const [anchorEl, setAnchorEl] = useState(null);
  const handleHowItWorksClickDrawer = () => {
    setOpenHowItWorks((prev) => !prev);
  };
  const handleHowItWorksClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleHowItWorksClose = () => {
    setAnchorEl(null);
  };

  const handleHowItWorksRoleSelect = (role) => {
    dispatch(setActiveSubTab(role));
    setAnchorE2(null);
    setAnchorEl(null);
    setDrawerOpen(false);
    navigate(`/how-it-works/${role}`);
  };

  const handleApplySelection = (selection) => {
    try {
      let url = "/apply-loan";
      const params = new URLSearchParams();
      const selectionConfig = {
        individual: { businessType: "individual", entityType: "individual" },
        company: { businessType: "entity", entityType: "company" },
        partnership: { businessType: "entity", entityType: "partnership" },
        proprietorship: { businessType: "entity", entityType: "proprietorship" },
      };

      const chosen = selectionConfig[selection];
      if (chosen) {
        localStorage.setItem("userBusinessType", chosen.businessType);
        localStorage.setItem("userEntityType", chosen.entityType);
        params.set(
          "applicantType",
          chosen.businessType === "entity" ? "entity" : "individual"
        );
        if (chosen.businessType === "entity") {
          params.set("entityType", chosen.entityType);
        }
      }

      const query = params.toString();
      if (query) url += `?${query}`;

      setAnchorApplyEl(null);
      setDrawerOpen(false);
      if (isAuthenticated) {
        window.open(url, "_blank");
      } else {
        setRedirectToApplyLoan(true);
        setShowLoginScreen(true);
      }
    } catch (error) {
      toast.error("Error:", error);
      window.open("/apply-loan", "_blank");
    }
  };

  const handleAddProfile = (roleType) => {
    setAnchorEl(null);
    setAnchorE2(null);
    setDrawerOpen(false);
    navigate("/add-profile", { state: { role: roleType } });
  };

  const handleTabChange = (url) => {
    try {
      dispatch(setActiveSubTab(""));
      setDrawerOpen(false);
      setOpenHowItWorks(false);
      navigate(url);
    } catch (error) {
      console.error("Error navigating to Home:", error);
      setDrawerOpen(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          // position: "fixed",
          // left: -5,
          // right: -5,
          // top: -5,
          // zIndex: 1100,
          backgroundImage: "url(./headerBackground.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          pb: 1,
          overflow:"hidden"
        }}
      >
        {/* Header */}
        <AppBar
          position="static"
          elevation={0}
          sx={{
            p: 1,
            px: { xs: 3, sm: 5 },
            backgroundColor: "transparent",
            backgroundImage: "none",
          }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            {/* Left Side - Hamburger & Logo */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {/* Hamburger Icon (Mobile) */}
              <IconButton
                onClick={toggleDrawer}
                sx={{
                  color: "#004AAD",
                  display: { lg: "none", xs: "block", sm: "block", md: "none" },
                }}
              >
                <MenuIcon />
              </IconButton>

              {/* Logo */}
              <Box sx={{ display: "flex" }}>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <img
                    src="/dequiLogoMobile.png"
                    alt="Dequi Logo Mobile"
                    style={{
                      height: drawerOpen ? "25px" : "35px",
                      transition: "height 0.3s",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                </Box>
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <img
                    src="/dequiLogo.png"
                    alt="Dequi Logo"
                    style={{
                      height: drawerOpen ? "25px" : "35px",
                      transition: "height 0.3s",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                </Box>
              </Box>
            </Box>

            {/* MIDDLE - TABS */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                flexGrow: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Tabs
                value={currentTabIndex}
                onChange={(event, newValue) => {
                  if (newValue === 2) {
                    handleHowItWorksClick(event);
                  } else if (newValue === 3 && isConsultant) {
                    setApplyEntityOpen(false);
                    setAnchorApplyEl(event.currentTarget);
                  } else {
                    handleTab(newValue);
                    // setActiveSubTab(null);
                  }
                }}
                indicatorColor="primary"
                textColor="primary"
                sx={{ boxShadow: "none" }}
              >
                <Tab
                  value={1}
                  label="Home"
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                />
                <Tab
                  value={4}
                  label="About Us"
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                />
                <Tab
                  value={2}
                  aria-controls={anchorEl ? "how-it-works-menu" : undefined}
                  aria-haspopup="true"
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                  }}
                  label={
                    <Box
                      sx={{ display: "flex", alignItems: "center" }}
                      onChange={(event) => {
                        setAnchorEl(true);
                      }}
                    >
                      How It Works <ArrowDropDownIcon />
                    </Box>
                  }
                  onClick={(event) => {
                    setAnchorEl(event.currentTarget); // open dropdown menu
                  }}
                />
                {(Object.keys(userDetail || {}).length === 0 ||
                  userDetail.UserType) &&
                  (!userDetail ||
                    (
                      userDetail.UserType ||
                      userDetail.userType ||
                      ""
                    ).toLowerCase() !== "lender") && (
                    <Tab
                      value={3}
                      aria-controls={isConsultant ? (anchorApplyEl ? "apply-loan-menu" : undefined) : undefined}
                      aria-haspopup={isConsultant ? "true" : undefined}
                      sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                      }}
                      label={
                        isConsultant ? (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            Apply Loan <ArrowDropDownIcon />
                          </Box>
                        ) : (
                          "Apply Loan"
                        )
                      }
                    />
                  )}
                <Tab
                  value={8}
                  label="SME Advisory"
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                />
              </Tabs>

              {/* Dropdown menu */}
              <Menu
                id="how-it-works-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleHowItWorksClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <MenuItem
                  onClick={() => handleHowItWorksRoleSelect("lender")}
                  sx={{
                    backgroundColor:
                      activeSubTab === "lender" ? "#f0f0f0" : "inherit",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  For Lender
                </MenuItem>
                <MenuItem
                  onClick={() => handleHowItWorksRoleSelect("consultant")}
                  sx={{
                    backgroundColor:
                      activeSubTab === "consultant" ? "#f0f0f0" : "inherit",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  For Consultant
                </MenuItem>
                <MenuItem
                  onClick={() => handleHowItWorksRoleSelect("borrower")}
                  sx={{
                    backgroundColor:
                      activeSubTab === "borrower" ? "#f0f0f0" : "inherit",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  For Borrower
                </MenuItem>
              </Menu>

              <Menu
                id="apply-loan-menu"
                anchorEl={anchorApplyEl === true ? null : anchorApplyEl}
                open={Boolean(anchorApplyEl)}
                onClose={() => {
                  setApplyEntityOpen(false);
                  setAnchorApplyEl(null);
                }}
                anchorOrigin={{
                  vertical: anchorApplyEl === true ? "top" : "bottom",
                  horizontal: anchorApplyEl === true ? "right" : "right",
                }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
              >
                {!applyEntityOpen ? (
                  <>
                    <MenuItem onClick={() => handleApplySelection("individual")}>
                      Individual
                    </MenuItem>
                    <MenuItem onClick={() => setApplyEntityOpen(true)}>
                      Entity
                    </MenuItem>
                  </>
                ) : (
                  <>
                    <MenuItem disabled sx={{ fontWeight: 600, opacity: 1 }}>
                      Entity
                    </MenuItem>
                    <MenuItem sx={{ pl: 3 }} onClick={() => handleApplySelection("company")}>
                      Company
                    </MenuItem>
                    <MenuItem sx={{ pl: 3 }} onClick={() => handleApplySelection("partnership")}>
                      Partnership Firm
                    </MenuItem>
                    <MenuItem sx={{ pl: 3 }} onClick={() => handleApplySelection("proprietorship")}>
                      Proprietorship Firm
                    </MenuItem>
                  </>
                )}
              </Menu>
            </Box>

            {/* Right Side - Buttons */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: 2,
              }}
            >
              {Object.keys(userDetail ? userDetail : {}).length === 0 ? (
                <>
                  <Button
                    variant="contained"
                    sx={{
                      px: 4,
                      py: 1,
                      fontSize: "1rem",
                      width: 150,
                      textTransform: "none",
                      borderColor: "#004AAD",
                      "&:hover": {
                        backgroundColor: "#003B82",
                        borderColor: "#003B82",
                      },
                    }}
                    startIcon={<LoginIcon />}
                    onClick={() => {
                      handleLogin();
                    }}
                  >
                    Login
                  </Button>
                </>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    onClick={(e) => handleUserMenuOpen(e)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      cursor: "pointer",
                      padding: "6px 12px",
                      borderRadius: 2,
                      transition: "all 0.2s ease",
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      "&:hover": {
                        backgroundColor: "rgba(0, 74, 173, 0.04)",
                        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    <Avatar
                      alt={userDetail?.Name || "User Avatar"}
                      src={""}
                      sx={{
                        width: 42,
                        height: 42,
                        border: "2px solid #004AAD",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        bgcolor: "#004AAD",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "1rem",
                      }}
                    >
                      {userDetail.Name
                        ? userDetail.Name.charAt(0).toUpperCase()
                        : null}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: "#1a1a1a",
                          fontSize: "0.95rem",
                          lineHeight: 1.2,
                        }}
                      >
                        {userDetail?.Name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          background:
                            "linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.95))",
                          backdropFilter: "blur(8px)",
                          border: "1px solid rgba(0,74,173,0.08)",
                          borderRadius: "20px",
                          padding: "4px 12px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            transform: "translateY(-1px)",
                            border: "1px solid rgba(0,74,173,0.15)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.8,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {userDetail?.UserType ? (
                            <>
                              <Box
                                component="span"
                                sx={{
                                  width: { xs: 6, sm: 7, md: 8 },
                                  height: { xs: 6, sm: 7, md: 8 },
                                  borderRadius: "50%",
                                  background:
                                    "linear-gradient(45deg, #4caf50, #45a049)",
                                  boxShadow: "0 2px 4px rgba(76,175,80,0.2)",
                                  display: "inline-block",
                                  flexShrink: 0,
                                  animation: "pulse 2s infinite",
                                }}
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.8,
                                }}
                              >
                                <Box
                                  component="span"
                                  sx={{
                                    color: "primary.main",
                                    fontWeight: 600,
                                    letterSpacing: "0.03em",
                                    fontSize: {
                                      xs: "0.7rem",
                                      sm: "0.75rem",
                                      md: "0.8rem",
                                    },
                                    textShadow: "0 1px 2px rgba(0,74,173,0.1)",
                                  }}
                                >
                                  {(
                                    userDetail?.UserType || userDetail?.userType
                                  ).toUpperCase()}
                                </Box>

                                {(
                                  userDetail?.UserType ||
                                  userDetail?.userType ||
                                  ""
                                ).toLowerCase() === "borrower" && (
                                  <>
                                    <Box
                                      component="span"
                                      sx={{
                                        mx: 0.5,
                                        color: "rgba(0,0,0,0.3)",
                                        fontSize: "0.85em",
                                        fontWeight: 300,
                                        transform: "scale(1.2)",
                                      }}
                                    >
                                      •
                                    </Box>
                                    <Box
                                      component="span"
                                      sx={{
                                        color: "text.secondary",
                                        fontWeight: 500,
                                        fontSize: {
                                          xs: "0.7rem",
                                          sm: "0.75rem",
                                          md: "0.8rem",
                                        },
                                      }}
                                    >
                                      {(
                                        userDetail?.BorrowerType ||
                                        userDetail?.borrowerType ||
                                        "ENTITY"
                                      ).toUpperCase()}
                                    </Box>
                                  </>
                                )}
                              </Box>{" "}
                            </>
                          ) : (
                            <Box
                              component="span"
                              sx={{
                                color: "primary.main",
                                fontWeight: 600,
                                letterSpacing: "0.03em",
                                fontSize: {
                                  xs: "0.7rem",
                                  sm: "0.75rem",
                                  md: "0.8rem",
                                },
                                textShadow: "0 1px 2px rgba(0,74,173,0.1)",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5, // small spacing between icon and text
                              }}
                            >
                              <AddIcon
                                sx={{ fontSize: 18, color: "#4caf50" }}
                              />
                              Add Profile
                            </Box>
                          )}
                        </Box>

                        {(
                          userDetail?.UserType ||
                          userDetail?.userType ||
                          ""
                        ).toLowerCase() === "borrower" &&
                          (userDetail?.EntityType ||
                            userDetail?.entityType) && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                color: "text.secondary",
                                fontWeight: 500,
                                fontSize: {
                                  xs: "0.65rem",
                                  sm: "0.7rem",
                                  md: "0.75rem",
                                },
                                opacity: 0.9,
                              }}
                            >
                              {(() => {
                                const entityType = (
                                  userDetail?.EntityType ||
                                  userDetail?.entityType ||
                                  ""
                                ).toLowerCase();
                                if (entityType === "company") return "COMPANY";
                                if (
                                  entityType === "partnership_firm" ||
                                  entityType === "partnership"
                                )
                                  return "PARTNERSHIP FIRM";
                                if (
                                  entityType === "propreitorship_firm" ||
                                  entityType === "propreitorship_firm" ||
                                  entityType === "proprietorship"
                                )
                                  return "PROPRIETORSHIP FIRM";
                                return entityType.toUpperCase();
                              })()}
                            </Box>
                          )}
                      </Typography>
                    </Box>
                  </Box>
                  <Menu
                    anchorEl={anchorE2}
                    open={Boolean(anchorE2)}
                    onClose={handleUserMenuClose}
                    anchorOrigin={{
                      vertical: anchorE2 === true ? "top" : "bottom",
                      horizontal: anchorE2 === true ? "right" : "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    PaperProps={{
                      elevation: 4,
                      sx: {
                        width: 250,
                        overflow: "visible",
                        mt: 1.5,
                        borderRadius: 3,
                        border: "1px solid rgba(0,0,0,0.08)",
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: "calc(50% - 10px)",
                          width: 20,
                          height: 20,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                          borderTop: "1px solid rgba(0,0,0,0.08)",
                          borderLeft: "1px solid rgba(0,0,0,0.08)",
                        },
                      },
                    }}
                    transitionDuration={250}
                  >
                    {userDetail?.UserType ? (
                      <MenuItem
                        onClick={handleDashboardClick}
                        sx={{
                          py: 1.8,
                          px: 2.5,
                          borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
                          "&:hover": {
                            bgcolor: "rgba(0, 74, 173, 0.04)",
                          },
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          transition: "all 0.2s",
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#004AAD",
                            fontSize: 20,
                            bgcolor: "rgba(0, 74, 173, 0.08)",
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect x="3" y="3" width="7" height="7"></rect>
                            <rect x="14" y="3" width="7" height="7"></rect>
                            <rect x="14" y="14" width="7" height="7"></rect>
                            <rect x="3" y="14" width="7" height="7"></rect>
                          </svg>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "0.95rem",
                              color: "#1a1a1a",
                            }}
                          >
                            Dashboard
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.75rem", color: "#666" }}
                          >
                            Access your account dashboard
                          </Typography>
                        </Box>
                      </MenuItem>
                    ) : (
                      <>
                        <MenuItem
                          onClick={() => handleAddProfile("borrower")}
                          sx={menuItemStyles}
                        >
                          <Box component="span" sx={iconBoxStyles}>
                            <PersonIcon />
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: 500,
                                fontSize: "0.95rem",
                                color: "#1a1a1a",
                              }}
                            >
                              Borrower
                            </Typography>
                          </Box>
                        </MenuItem>

                        <MenuItem
                          onClick={() => handleAddProfile("lender")}
                          sx={menuItemStyles}
                        >
                          <Box component="span" sx={iconBoxStyles}>
                            <BusinessIcon />
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: 500,
                                fontSize: "0.95rem",
                                color: "#1a1a1a",
                              }}
                            >
                              Lender
                            </Typography>
                          </Box>
                        </MenuItem>

                        <MenuItem
                          onClick={() => handleAddProfile("consultant")}
                          sx={menuItemStyles}
                        >
                          <Box component="span" sx={iconBoxStyles}>
                            <GroupIcon />
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: 500,
                                fontSize: "0.95rem",
                                color: "#1a1a1a",
                              }}
                            >
                              Consultant
                            </Typography>
                          </Box>
                        </MenuItem>
                      </>
                    )}
                    {anchorE2 !== true && (
                      <MenuItem
                        onClick={handleLogout}
                        sx={{
                          py: 1.8,
                          px: 2.5,
                          "&:hover": {
                            bgcolor: "rgba(211, 47, 47, 0.04)",
                          },
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          transition: "all 0.2s",
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#d32f2f",
                            fontSize: 20,
                            bgcolor: "rgba(211, 47, 47, 0.08)",
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16 17 21 12 16 7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                          </svg>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              fontSize: "0.95rem",
                              color: "#1a1a1a",
                            }}
                          >
                            Logout
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.75rem", color: "#666" }}
                          >
                            Sign out of your account
                          </Typography>
                        </Box>
                      </MenuItem>
                    )}
                  </Menu>
                </Box>
              )}
            </Box>
          </Toolbar>
        </AppBar>
     </Box>
        {/* Drawer (Sidebar) */}
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer}
          sx={{
            "& .MuiDrawer-paper": {
              width: 290,
              bgcolor: "#f4f4f4",
            },
          }}
        >
          <Box sx={{ width: 250, p: 2, bgcolor: "#f4f4f4", height: "100%" }}>
            {/* Header Section Inside Drawer (Hamburger before Logo) */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <IconButton onClick={toggleDrawer} sx={{ color: "#004AAD" }}>
                <MenuIcon />
              </IconButton>
              <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <img
                  src="/dequiLogoMobile.png"
                  alt="Dequi Logo Mobile"
                  style={{
                    height: "30px",
                    transition: "height 0.3s",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate("/");
                    setDrawerOpen(false);
                  }}
                />
              </Box>
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <img
                  src="/dequiLogo.png"
                  alt="Dequi Logo"
                  style={{
                    height: "30px", // Reduce logo size in drawer
                    transition: "height 0.3s",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate("/");
                    setDrawerOpen(false);
                  }}
                />
              </Box>
            </Box>

            {/* Login/Register Buttons in Drawer (In One Line) */}
            {Object.keys(userDetail ? userDetail : {}).length === 0 ? (
              <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                <Button
                  variant="outlined"
                  sx={{
                    color: "#004AAD",
                    textTransform: "none",
                    flex: 1,
                    fontSize: "0.9rem",
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                      borderColor: "#003B82",
                    },
                  }}
                  startIcon={<LoginIcon />}
                  onClick={() => {
                    handleLogin();
                    setDrawerOpen(false);
                  }}
                >
                  Login
                </Button>
              </Box>
            ) : (
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}
              >
                <Avatar
                  alt={userDetail.Name || "User Avatar"}
                  src={""}
                  sx={{
                    width: 42,
                    height: 42,
                    border: "2px solid #004AAD",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    bgcolor: "#004AAD",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "1rem",
                  }}
                >
                  {userDetail?.Name
                    ? userDetail?.Name.charAt(0).toUpperCase()
                    : null}
                </Avatar>
                <Box>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", color: "black" }}
                  >
                    {userDetail?.Name}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      background:
                        "linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.95))",
                      backdropFilter: "blur(8px)",
                      border: "1px solid rgba(0,74,173,0.08)",
                      borderRadius: "20px",
                      padding: "4px 12px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                        transform: "translateY(-1px)",
                        border: "1px solid rgba(0,74,173,0.15)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.8,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {userDetail?.UserType ? (
                        <>
                          <Box
                            component="span"
                            sx={{
                              width: { xs: 6, sm: 7, md: 8 },
                              height: { xs: 6, sm: 7, md: 8 },
                              borderRadius: "50%",
                              background:
                                "linear-gradient(45deg, #4caf50, #45a049)",
                              boxShadow: "0 2px 4px rgba(76,175,80,0.2)",
                              display: "inline-block",
                              flexShrink: 0,
                              animation: "pulse 2s infinite",
                            }}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.8,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: "primary.main",
                                fontWeight: 600,
                                letterSpacing: "0.03em",
                                fontSize: {
                                  xs: "0.7rem",
                                  sm: "0.75rem",
                                  md: "0.8rem",
                                },
                                textShadow: "0 1px 2px rgba(0,74,173,0.1)",
                              }}
                            >
                              {(
                                userDetail?.UserType || userDetail?.userType
                              )?.toUpperCase()}
                            </Box>

                            {(
                              userDetail?.UserType ||
                              userDetail?.userType ||
                              ""
                            )?.toLowerCase() === "borrower" && (
                              <>
                                <Box
                                  component="span"
                                  sx={{
                                    mx: 0.5,
                                    color: "rgba(0,0,0,0.3)",
                                    fontSize: "0.85em",
                                    fontWeight: 300,
                                    transform: "scale(1.2)",
                                  }}
                                >
                                  •
                                </Box>
                                <Box
                                  component="span"
                                  sx={{
                                    color: "text.secondary",
                                    fontWeight: 500,
                                    fontSize: {
                                      xs: "0.7rem",
                                      sm: "0.75rem",
                                      md: "0.8rem",
                                    },
                                  }}
                                >
                                  {(
                                    userDetail?.BorrowerType ||
                                    userDetail?.borrowerType ||
                                    "ENTITY"
                                  )?.toUpperCase()}
                                </Box>
                              </>
                            )}
                          </Box>{" "}
                        </>
                      ) : (
                        <Box
                          component="span"
                          sx={{
                            color: "primary.main",
                            fontWeight: 600,
                            letterSpacing: "0.03em",
                            fontSize: {
                              xs: "0.7rem",
                              sm: "0.75rem",
                              md: "0.8rem",
                            },
                            textShadow: "0 1px 2px rgba(0,74,173,0.1)",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5, // small spacing between icon and text
                          }}
                          onClick={() => handleUserMenuDrawerOpen()}
                        >
                          <AddIcon sx={{ fontSize: 18, color: "#4caf50" }} />
                          Add Profile
                        </Box>
                      )}
                    </Box>

                    {(
                      userDetail?.UserType ||
                      userDetail?.userType ||
                      ""
                    )?.toLowerCase() === "borrower" &&
                      (userDetail?.EntityType || userDetail?.entityType) && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            color: "text.secondary",
                            fontWeight: 500,
                            fontSize: {
                              xs: "0.65rem",
                              sm: "0.7rem",
                              md: "0.75rem",
                            },
                            opacity: 0.9,
                          }}
                        >
                          {(() => {
                            const entityType = (
                              userDetail?.EntityType ||
                              userDetail?.entityType ||
                              ""
                            )?.toLowerCase();
                            if (entityType === "company") return "COMPANY";
                            if (
                              entityType === "partnership_firm" ||
                              entityType === "partnership"
                            )
                              return "PARTNERSHIP FIRM";
                            if (
                              entityType === "propreitorship_firm" ||
                              entityType === "propreitorship_firm" ||
                              entityType === "proprietorship"
                            )
                              return "PROPRIETORSHIP FIRM";
                            return entityType?.toUpperCase();
                          })()}
                        </Box>
                      )}
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Vertical List for Tabs */}
            <List sx={{ mb: 3 }} style={{ cursor: "pointer" }}>
              {/* Home */}
              <ListItem
                button
                selected={currentTabIndex === 1}
                sx={currentTabIndex === 1 ? selectedStyle : {}}
                onClick={() => {
                  handleTabChange("/");
                }}
              >
                <ListItemText primary="Home" />
              </ListItem>

              {/* How It Works - Collapsible */}
              <ListItem
                button
                // selected={currentTabIndex === 2}
                // sx={currentTabIndex === 2 ? selectedStyle : {}}
                onClick={handleHowItWorksClickDrawer}
              >
                <ListItemText primary="How It Works" />
                {openHowItWorks || currentTabIndex === 2 ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </ListItem>
              <Collapse
                in={openHowItWorks || currentTabIndex === 2}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  <ListItem
                    button
                    selected={activeSubTab === "borrower"}
                    sx={activeSubTab === "borrower" ? selectedStyle : { pl: 4 }}
                    onClick={() => {
                      try {
                        handleHowItWorksRoleSelect("borrower");
                        setDrawerOpen(false);
                      } catch (error) {
                        console.error("Error navigating:", error);
                        setDrawerOpen(false);
                      }
                    }}
                  >
                    <ListItemText primary="For Borrower" />
                  </ListItem>
                  <ListItem
                    button
                    selected={activeSubTab === "lender"}
                    sx={activeSubTab === "lender" ? selectedStyle : { pl: 4 }}
                    onClick={() => {
                      try {
                        handleHowItWorksRoleSelect("lender");
                        setDrawerOpen(false);
                      } catch (error) {
                        console.error("Error navigating:", error);
                        setDrawerOpen(false);
                      }
                    }}
                  >
                    <ListItemText primary="For Lender" />
                  </ListItem>
                  <ListItem
                    button
                    selected={activeSubTab === "consultant"}
                    sx={
                      activeSubTab === "consultant" ? selectedStyle : { pl: 4 }
                    }
                    onClick={() => {
                      try {
                        handleHowItWorksRoleSelect("consultant");
                        setDrawerOpen(false);
                      } catch (error) {
                        console.error("Error navigating:", error);
                        setDrawerOpen(false);
                      }
                    }}
                  >
                    <ListItemText primary="For Consultant" />
                  </ListItem>
                </List>
              </Collapse>

              {/* Apply Loan */}
              {userDetail.UserType &&
                (!userDetail ||
                  (
                    userDetail.UserType ||
                    userDetail.userType ||
                    ""
                  ).toLowerCase() !== "lender") && (
                  <ListItem
                    button
                    selected={currentTabIndex === 3}
                    sx={currentTabIndex === 3 ? selectedStyle : {}}
                    onClick={() => {
                      try {
                        if (
                          (userDetail?.UserType || userDetail?.userType || "")
                            .toString()
                            .toLowerCase() === "consultant"
                        ) {
                          setAnchorApplyEl(true);
                        } else if (isAuthenticated) {
                          window.open("/apply-loan", "_blank");
                          setDrawerOpen(false);
                        } else {
                          setRedirectToApplyLoan(true);
                          setShowLoginScreen(true);
                          setDrawerOpen(false);
                        }
                      } catch (error) {
                        console.error("Error navigating to Apply Loan:", error);
                        setDrawerOpen(false);
                      }
                    }}
                  >
                    <ListItemText primary="Apply Loan" />
                  </ListItem>
                )}

              {/* About Us */}
              {/* {console.log("Current Tab Index:", currentTabIndex)} */}
              <ListItem
                button
                selected={currentTabIndex === 4}
                sx={currentTabIndex === 4 ? selectedStyle : {}}
                onClick={() => {
                  handleTabChange("/about-us");
                }}
              >
                <ListItemText primary="About Us" />
              </ListItem>

              <ListItem
                button
                selected={currentTabIndex === 8}
                sx={currentTabIndex === 8 ? selectedStyle : {}}
                onClick={() => {
                  handleTabChange("/sme-advisory");
                }}
              >
                <ListItemText primary="SME Advisory" />
              </ListItem>

              {/* Dashboard & Logout */}
              {Object.keys(userDetail ? userDetail : {}).length !== 0 && (
                <>
                  {userDetail?.UserType && (
                    <ListItem
                      button
                      selected={currentTabIndex === 9}
                      sx={currentTabIndex === 9 ? selectedStyle : {}}
                      onClick={() => {
                        try {
                          window.open("/dashboard", "_blank");
                          setDrawerOpen(false);
                        } catch (error) {
                          console.error(
                            "Error navigating to Dashboard:",
                            error
                          );
                          setDrawerOpen(false);
                        }
                      }}
                    >
                      <ListItemText primary="Dashboard" />
                    </ListItem>
                  )}
                  <ListItem
                    button
                    onClick={() => {
                      handleLogout();
                      setDrawerOpen(false);
                    }}
                  >
                    <ListItemText primary="Logout" />
                  </ListItem>
                </>
              )}
            </List>

            {/* Support Email (Placed at Bottom) */}
            <Box
              sx={{
                position: "absolute",
                bottom: 16,
                left: 16,
                right: 16,
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "center",
              }}
            >
              <MailOutlineIcon sx={{ color: "#18CB96" }} />
              <Typography
                variant="body2"
                sx={{ color: "#18CB96", fontStyle: "italic" }}
              >
                contact@dequitec.com
              </Typography>
            </Box>
          </Box>
        </Drawer>
      {/* </Box> */}

      {currentPath === "/" && (
        <>
          {currentTabIndex === 2 && <HowItWorks />}
          {currentTabIndex === 3 &&
            (isAuthenticated
              ? window.open("/apply-loan", "_blank")
              : setShowLoginScreen(true))}
          {currentTabIndex === 4 && <AboutUs />}
          {currentTabIndex === 5 && <Careers />}
          {currentTabIndex === 6 && <ContactUs />}
          {currentTabIndex === 7 && (
            <LoanEligibilityCalculator
              setShowLoginScreen={setShowLoginScreen}
              setRedirectToApplyLoan={setRedirectToApplyLoan}
            />
          )}
          {currentTabIndex !== 7 &&
            currentTabIndex !== 1 &&
            currentTabIndex !== 3 && <NextStepCard />}
        </>
      )}

      {showLoginScreen && (
        <LoginScreen
          showLoginScreen={showLoginScreen}
          setShowLoginScreen={setShowLoginScreen}
          setShowRegister={setShowRegister}
          setShowOTPVarification={setShowOTPVarification}
          setShowMobileOTP={setShowMobileOTP}
          setRequestData={setRequestData}
          requestData={requestData}
        />
      )}
      {showRegister && (
        <RegisterUser
          showRegister={showRegister}
          setShowRegister={setShowRegister}
          setShowLoginScreen={setShowLoginScreen}
          setShowOTPVarification={setShowOTPVarification}
          setRequestData={setRequestData}
          requestData={requestData}
          setShowMobileOTP={setShowMobileOTP}
        />
      )}
      {showOTPVarification && (
        <OTPVerification
          key={`otp-verification-${new Date().getTime()}`}
          showOTPVarification={showOTPVarification}
          setShowOTPVarification={setShowOTPVarification}
          showMobileOTP={showMobileOTP}
          setShowWelcome={setShowWelcome}
          setRequestData={setRequestData}
          requestData={requestData}
          redirectToApplyLoan={redirectToApplyLoan}
        />
      )}
      {showWelcome && (
        <WelcomeScreen
          showWelcome={showWelcome}
          setShowWelcome={setShowWelcome}
          requestData={requestData}
          redirectToApplyLoan={redirectToApplyLoan}
        />
      )}
      <LogoutDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
      />
    </>
  );
};

export default Header;
